import { UploadFile } from "antd/lib/upload/interface";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form"
import { useAuthenticationDataContext } from "../../Helpers/AuthenticationDataProvider";
import { usePopupContext } from "../../Helpers/PopupProvider";
import useFetchWrapper, { HttpResponse } from "../../Helpers/useFetchWrapper";
import useObjectHelper from "../../Helpers/useObjectHelper";
import { UsersResponse } from "../../pages/MentorsMenteesList/MentorsMenteesList.model";
import { Resource, ResourceResponse } from "../../pages/Resources/AllResourcesTab/AllResourcesTab.model";
import { CreateFeedbackRequest, Feedback, FeedbackTypes, Props, User } from "./CreateFeedback.model";

export const feedbackTypes: FeedbackTypes[]	= [FeedbackTypes.BugReport, FeedbackTypes.FlagOfAbuse, FeedbackTypes.GeneralFeedback];

export const useCreateFeedback = ({onClose}: Props) => {
	const [topics, setTopics] = useState<string[]>();
	const [files, setFiles] = useState<UploadFile<any>[]>([]);
	const [resources, setResources] = useState<Resource[]>();
	const [users, setUsers] = useState<User[]>();
	const [showReportType, setShowReportType] = useState(false);
	const [isSubmitted, setIsSubmitted] = useState(false);
	const { get, put, postFormData } = useFetchWrapper();
	const { cleanObj, objToFormData } = useObjectHelper();
	const { onPopupClose, onPopupOpen } = usePopupContext();

	const { email } = useAuthenticationDataContext();
	const { control, formState: { errors }, handleSubmit, watch } = useForm(
		{
			defaultValues: {
				description: '',
				feedbackType: FeedbackTypes.GeneralFeedback,
				reportType: 'none',
				resourceReported: undefined,
				shortDescription: '',
				topics: undefined,
				userReported: undefined,
			}
		}
	);

	const selectedFeedbackType = watch('feedbackType');
	const reportType = watch('reportType');

	const getIconByFileType = (extension: string | undefined) => {
		switch (extension) {
			case "image/jpg":
			case "image/jpeg":
			case "image/png": return "file-image";
			case "application/pdf": return "file-pdf";
			case "application/vnd.openxmlformats-officedocument.wordprocessingml.document": return "file-word";
			case "video/quicktime": return "file-video";
			default: return "file-alt";
		}
	}
	const getResources = async () => {
    const response: HttpResponse<ResourceResponse> = await get(`/resource/global?status=Published&page=${1}&size=${1000}`);
    response.parsedBody && setResources(response.parsedBody.resources);  
	}

	const getTopics = async() => {
		const response: HttpResponse<string[]> = await get('/review/feedback-topic');
		if(response.parsedBody){
			setTopics(response.parsedBody);
		}
	}

	const getUsers = async () => {
		const response: HttpResponse<UsersResponse[]> = await get(`/user/all-types`);
		response.parsedBody && setUsers(response.parsedBody.map((item) => {
			const { firstName, lastName, imageId, userId, role } = item;
			return { firstName, imageId, lastName, role, userId, };
		}));
	}

	const onChangeFiles = ({fileList}: any) => {
		setFiles(fileList);
	}

	const submitFeedback = async (data: Feedback) => {
		const content: { [key: string]: any } = files.reduce((acc, curr, index) => ({ ...acc, [`content${index + 1}`]: curr.originFileObj }), {});
		const formData: CreateFeedbackRequest = {
			...cleanObj(data),
			...content
		}
		const response = await postFormData('/review/feedback', objToFormData(formData));
		if (response.status === 200) {
			setIsSubmitted(true);
		}
	}

	useEffect(() => {
		if (selectedFeedbackType === FeedbackTypes.FlagOfAbuse) {
			getResources();
			getUsers();
			setShowReportType(true);
		}
		else setShowReportType(false);
	}, [selectedFeedbackType]);

	useEffect(() => {
		onPopupOpen();
		getTopics();
	}, []);

	return {
		control,
		errors,
		getIconByFileType,
		handleSubmit,
		onChangeFiles,
		onPopupClose,
		state: {
			email,
			files,
			isSubmitted,
			reportType,
			resources,
			showReportType,
			topics,
			users
		},
		submitFeedback
	}
}